import { JianList as JianListComponent } from 'core/components/JianList';

/** 広島の事案一覧のコンポーネント。 */
export const HiroshimaJianList = () => {
  return <JianListComponent />;
};
